<div class="scanner-container layout f_col pl_10 pr_10">
  <div id="scanner" class="loader_scan" [class.scanner-hidden]="!started">
    <div #scanner_wrapper class="scanner_wrapper">
      <ngx-scanner-qrcode #scanner #action="scanner" [config]="config" (event)="onCodeResult($event, action)"></ngx-scanner-qrcode>
      <div class="scanner_bottom">
        <fa-icon icon="arrow-left" (click)="nav.goBack()"></fa-icon>
        <fa-icon *ngIf="availableDevices.length > 1" icon="camera-rotate" (click)="nextCamera()"></fa-icon>
      </div>
    </div>
  </div>
</div>
